import { useEffect } from 'react';
import { api } from '../api/client';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

async function doSubscribe() {
  if (!VAPID_PUBLIC_KEY) return;
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  const reg = await navigator.serviceWorker.ready;
  const existing = await reg.pushManager.getSubscription();
  const subscription = existing || await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
  });

  await api('/api/notifications/subscribe', {
    method: 'POST',
    body: JSON.stringify(subscription.toJSON()),
  });
}

// Called from a button click in settings — requests permission then subscribes.
// Must be triggered by a user gesture so the browser allows the permission prompt.
export async function requestAndSubscribePush() {
  if (typeof Notification === 'undefined') return 'unsupported';
  const result = await Notification.requestPermission();
  if (result === 'granted') {
    try { await doSubscribe(); } catch (err) { console.log('Push subscribe failed:', err.message); }
  }
  return result;
}

// Auto-subscribes on login only if permission was already granted by a previous
// user gesture. Never prompts the browser permission dialog automatically.
export default function usePushNotifications(isLoggedIn) {
  useEffect(() => {
    if (!isLoggedIn) return;
    if (typeof Notification === 'undefined') return;
    if (Notification.permission !== 'granted') return;

    doSubscribe().catch(err => console.log('Push subscription failed:', err.message));
  }, [isLoggedIn]);
}
